// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__zGfu9","head":"Table_head__3L-Ra","col":"Table_col__3MtBG"};